'use client';
import React, { useEffect } from "react";
import { reportClientError } from "@/utils/clientErrorReporter";
import PropTypes from "prop-types";

const Error = ({ error, reset }) => {
  useEffect(() => {
    reportClientError({
      kind: "next.route_error",
      error,
      context: { digest: error?.digest },
      tags: { boundary: "app/error.jsx" },
    });
  }, [error]);

  return (
    <div className="p-6">
      <h2 className="text-lg font-semibold">Se ha producido un error del lado del cliente</h2>
      <p className="mt-2 text-sm opacity-80">
        Intenta recargar la página. Si el problema persiste, por favor comunícalo al área de soporte.
      </p>
      <div className="mt-4 flex gap-2">
        <button className="btn btn-primary" onClick={() => reset()}>
          Reintentar
        </button>
        <button className="btn" onClick={() => window.location.reload()}>
          Recargar
        </button>
      </div>
    </div>
  );
}

export default Error;


Error.propTypes = {
  error: PropTypes.any,
  reset: PropTypes.any

};
